import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-view',
  templateUrl:'./view.component.html',
  styleUrls: ['./view.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class ViewComponent implements OnInit {
  contactId:any;
  contactData:any
  imageUrl=environment.apiUrls.imageUrl;



  constructor(private apiService:ApiService,private activatedroute:ActivatedRoute) { 
    this.activatedroute.paramMap.subscribe(params => { 
      this.contactId = params.get('id');      
  });

  }

  ngOnInit(): void {
    this.getcontactById()
  }
  getcontactById(){
    this.apiService.getContactById(this.contactId).subscribe((res:any)=>{
      if(res.statusCode == 200){
        this.contactData =res.data 
      }
    })
  }
}
